import React from "react";
import { Link } from "react-router-dom";

const ResourcesSideNavBar = ({ data }) => {
 // console.log(data);
  //   make sure we have the right data
  if (!data || data.length === 0) return null;

  // make an array of categories and remove duplicates
  let categories = [...new Set(data.map((el) => el.attributes.category))];

  return (
    <div id="w-node-dbfcdee8-4921-979b-1711-a3ae64740b2c-b6a712a5">
      {/* loop throuhg our categories */}
      {categories.map((category) => {
        // filter out only links that are within that category
        let links = data.filter((subItem) => subItem.attributes.category === category);

        return (
          <div className="divresourcelinks">
            {/* display our category header */}
            <span className="linkresource w-inline-block">
              <div>{category}</div>
            </span>

            {/* display all sub links */}
            {links.map((item) => {
              return (
                <Link to={`/resources/${item.id}`} className="linkresourcechild w-inline-block">
                  <div>{item.attributes.title}</div>
                </Link>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ResourcesSideNavBar;
